import React, {ReactElement} from "react";
import {Loader} from "../../components/Loader";
import {Table} from "../../components/Table/Table";
import {Dictionary} from "../../components/Dictionary";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {RightAside} from "../../components/Aside/RightAside";
import {SignTurnRightFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {StatusPage} from "../StatusPage";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {DetailsWithList} from "../../components/DetailsWithList";
import {TBody} from "../../components/Table/TBody";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {ListLoader} from "../../components/ListLoader";

export class ReceiptDetails extends DetailsWithList {
    protected dictionary: Dictionary = new Dictionary();

    componentDidMount() {
        if (this.user.hasRight('receipt/details') === false && this.user.hasRight('receipt/edit') === false) {
            return;
        }
        this.fetchUrl = '/receipt/' + window.location.pathname.split('/').pop();
        this.fetchItem();
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }

        let items: any = [], quantity: number = 0, quantity_received: number = 0, quantity_diff: number = 0;

        for (let i in this.state?.items) {
            let elem = this.state?.items[i];
            items.push([
                elem.id + " ",
                elem.reference_id,
                elem.suborder_id,
                elem.product_id ? Util.link(elem.sku, '/product/details/' + elem.product_id) : elem.sku,
                elem.name,
                parseInt(elem.quantity),
                parseInt(elem.quantity_received) || '-',
                parseInt(elem.quantity_diff) || '-'
            ]);
            quantity = quantity + parseInt(elem.quantity);
            quantity_received = quantity_received + parseInt(elem.quantity_received);
            quantity_diff = quantity_diff + parseInt(elem.quantity_diff);
        }

        const saveUrl = "/receipt/" + this.state.item.id;

        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row gx-4">
                    {this.state?.item.nfo &&
                        <div className="col-md-12 details">
                            <div className={Util.alertTypeByStatus(this.state.item.status)} role="alert">
                                {this.state?.item.nfo}
                            </div>
                        </div>
                    }

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['receipt-details']}
                            {this.isEditable(true) && <SysButton onClick={this.editDetails} type={'PencilFill'}
                                                                 text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getDetails(false)}
                            </table>
                        </div>
                        {this.isEditable(true) && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-details"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-receipt-details']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getDetails(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['fulfillment-info']}</h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['created_at'], DateTime.create({
                                            value: this.state?.item.created_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['imported_at'], DateTime.create({
                                            value: this.state?.item.imported_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['sync_at'], DateTime.create({
                                            value: this.state?.item.sync_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['closed_at'], DateTime.create({
                                            value: this.state?.item.closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['cancelled_at'], DateTime.create({
                                            value: this.state?.item.cancelled_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['updated_by'], this.state?.item.updated_by || ''],
                                        [this.dictionary.get['updated_at'], DateTime.create({
                                            value: this.state?.item.updated_at || '',
                                            inline: true
                                        })],
                                    ]
                                }}/>
                            </table>
                        </div>
                    </div>

                    <div className="col-12">
                        <h6>
                            {this.dictionary.get['receipt-items']} - ({items.length} {this.dictionary.get['pc']})
                        </h6>
                        <div className="row" style={{marginBottom: '6px'}}>
                            <div className="col-12 col-sm-6 col-md-4" key={TBody.index++}>
                                {this.dictionary.get['quantity']}:&nbsp;<FormattedNumber
                                value={quantity}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-6 col-md-4" key={TBody.index++}>
                                {this.dictionary.get['quantity_shipped']}:&nbsp;<FormattedNumber
                                value={quantity_received}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-6 col-md-4" key={TBody.index++}>
                                {this.dictionary.get['quantity_diff']}:&nbsp;<FormattedNumber
                                value={quantity_diff}/>&nbsp;{this.dictionary.get['pc']}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th className="sortable" data-sortkey="i.`id`"> ID
                                        <i className="bi bi-sort-down-alt"></i></th>
                                    <th className="sortable" data-sortkey="i.`reference_id`">
                                        {this.dictionary.get['reference_id']}</th>
                                    <th className="sortable" data-sortkey="i.`fulfillment_id`">
                                        {this.dictionary.get['fulfillment_id']}</th>
                                    <th className="sortable" data-sortkey="i.`sku`">{this.dictionary.get['sku']}</th>
                                    <th className="sortable" data-sortkey="i.`name`">{this.dictionary.get['name']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity`">{this.dictionary.get['quantity']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity_received`">{this.dictionary.get['quantity_received']}</th>
                                    <th className="sortable"
                                        data-sortkey="i.`quantity_diff`">{this.dictionary.get['quantity_diff']}</th>
                                </tr>
                                </thead>
                                <Table.TBody {...{data: items}}/>
                            </table>
                        </div>
                    </div>
                </div>
                {!items.length && <ListLoader/>}
            </div>
        );
    }

    private isEditable(onlyRights: boolean = false): boolean {
        if (this.user.hasRight('receipt/edit') === false) {
            return false;
        }
        if (onlyRights) {
            return true;
        }
        switch (this.state?.item.status) {
            case 'draft':
            case 'scheduled':
            case 'open':
            case 'b2b-open':
            case 'cancelled':
            case 'address-error':
            case 'unknown-product':
            case 'duplication-error':
            case 'customer-error':
            case 'on-hold':
                return true;
        }
        return false;
    }

    private getStatus(input: boolean, status: any): ReactElement {
        if (!input || ['address-error', 'completed'].indexOf(status) !== -1) {
            return Util.status(status, {tooltip: this.dictionary.get[status + '-info']});
        }
        let statusList: string[];
        switch (status) {
            case 'draft':
            case 'scheduled':
            case 'open':
            case 'b2b-open':
            case 'cancelled':
            case 'unknown-product':
            case 'duplication-error':
            case 'customer-error':
            case 'on-hold':
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'customer-error', 'on-hold'];
                break;
            case 'in-transit':
            case 'b2b-in-transit':
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'on-hold', 'in-transit', 'b2b-in-transit'];
                break;
            case 'closed':
            case 'close-error':
                statusList = ['closed', 'close-error']
                break;
            // case 'error':
            default:
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'on-hold', 'in-transit', 'b2b-in-transit', 'error', 'completed', 'closed', 'close-error'];
        }

        return (
            <FormGroup.Select {...{
                id: 'status',
                skipLabel: true,
                basic: 'please-select',
                items: statusList,
                defaultValue: status
            }}/>
        );
    }

    private getType(input: boolean, type: any): ReactElement {
        if (!input || !this.isEditable() || ['draft'].indexOf(this.state?.item.status) === -1) {
            return type;
        }
        return (
            <FormGroup.Select {...{
                id: 'type',
                skipLabel: true,
                basic: 'please-select',
                items: ['B2C', 'B2B'],
                defaultValue: type
            }}/>
        );
    }

    private getInput(input: boolean, id: string, value: any): ReactElement {
        if (!input || !this.isEditable()) {
            return value;
        }
        if (value && React.isValidElement(value)) {
            value = (value as ReactElement).props.children as string;
        }
        return (
            <FormGroup.Input {...{skipLabel: true, id: id, defaultValue: value}}/>
        );
    }

    private getDetails(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['origin'], this.state?.item.service_name || ''],
                    [this.dictionary.get['id'], Util.copyCell(this.state?.item.id || '')],
                    [this.dictionary.get['reference_id'], Util.copyCell(this.state?.item.reference_id || '')],
                    [this.dictionary.get['reference_no'], Util.copyCell(this.state?.item.reference_no || '')],
                    [this.dictionary.get['reference_name'], this.getInput(input, 'reference_name', Util.copyCell(this.state?.item.reference_name || ''))],
                    [this.dictionary.get['status'], this.getStatus(input, this.state?.item.status)],
                ]
            }}/>
        );
    }

    private editDetails(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-details') as HTMLElement);
    }
}
